import {Select, Input, Button, Col, DatePicker} from "antd";

import styled from "styled-components";
import {CloseOutlined} from "@ant-design/icons";

export const StyledRangePickerContainer = styled.div`
    @media (max-width: 768px) {
        .ant-picker-panels {
            flex-direction: column;
        }
    }
    @media (max-width: 768px) {
        .ant-picker-dropdown {
            top: 100px;
        }
    }
`;

export const RangePicker = styled(DatePicker)`
    top: 100px;

    @media (max-width: 768px) {
        .ant-picker-dropdown {
            top: 100px;
        }
    }
`;

export const SelectField = styled(Select)`
    width: 100%;
    margin-bottom: ${props => (props.mb ? props.mb : "20px")};
    @media (max-width: 768px) {
        display: flex;
        width: 100%;
        .ant-select-selector {
            width: 100%;
            font-size: 12px;
        }
    }
`;

export const DateSelectCol = styled(Col)`
    display: flex;
    margin-left: 8px;
    @media (max-width: 768px) {
        margin-left: 0px;
        margin-bottom: 20px;
    }
`;

export const SearchInput = styled(Input.Search)`
    @media (max-width: 768px) {
        min-width: 235px;
    }
    .ant-input-group-addon {
        bottom: 3px;
        background-color: transparent;
    }
`;

export const EnterButton = styled(Button)`
    margin-top: 3px;
`;

export const CloseIcon = styled(CloseOutlined)`
    cursor: pointer;
`;
